interface Scripts {
  name: string;
  src: string;
}

// Put here all external JS library location paths
// eslint-disable-next-line
export const ScriptStore: Scripts[] = [{ name: 'skrollr', src: 'assets/hero/skrollr.js' }];
